



























import {Component, Mixins } from "vue-property-decorator";
import Dialog from "@/mixins/Dialog";

@Component({})
export default class ConfirmDialog extends Mixins(Dialog){

  // icon图标类型
  // @Prop({
  //   type:String,
  //   default:'success'
  // })



  private get dialogType(){
    switch (this.type){
      case'success':
        return 'el-icon-success'
      case 'error':
        return 'el-icon-error'
      case 'warning':
        return 'el-icon-warning'
      case 'info':
        return 'el-icon-info'
      default:
        return 'el-icon-success'
    }
  }

  private title:string = '提示信息'
  private type:string='success';
  private dialogContent:string = ''

  public open(  dialogContent:string , type:string ){
    this.type = type;
    this.dialogContent = dialogContent;
    this.dialog_visible = true;
  }

  public handleClose(){
    this.dialog_visible = false;
  }
  //点击确认按钮
  public confirm(){
    this.$emit('success')
    this.dialog_visible = false;
  }

}
